/**
 * WizTableForm 列表搜索选择组件
 * @author jzhu
 * @date 2020-01-13
 * PS: 1、自定义使用onSubmit未完成，待完善（若有需要的请@我)
 */
import React from "react";
import PropTypes from "prop-types";
import { connect } from "dva";
import "@/styles/containers/common/wizTableForm/index.less";
import { modelUtils } from "@/utils";
import { utils_tool, component_tool, framework_tool } from "@/tool";
import * as Config from "./config";
import classnames from "classnames";
const {
  WizSelect,
  WizModal,
  WizRow,
  WizCol,
  WizSpin,
  WizCard,
  WizSearchBar,
  WizDataTable,
  WizListSelect,
  WizTooltip,
  WizTreeSelectList,
  WizTreeSelect,
  WizButton,
} = component_tool;
const { WizContainer } = framework_tool;
const { getPageData, getType } = utils_tool;

class WizTableForm extends WizContainer {
  componentName = "WizTableForm";

  constructor(props) {
    super(props);
    let { selectType } = props;
    let value;
    let selectedKeys;
    if (selectType !== "checkbox") {
      value = props.value || undefined;
      selectedKeys = value ? [value] : [];
    } else {
      value = props.value || [];
      selectedKeys = value || [];
    }
    this._initData = {
      value,
      valueRows: props.initRows,
    };
    this.state = {
      value,
      valueRows: props.initRows,
      modalVisible: props.visible,
      searchParams: {},
      selectedKeys,
      selectedRows: props.initRows,
      timestamp: undefined,
      showDataTable: true,
      showArrow: props.showArrow,
    };
    this._rowsData = {};
    this._putAllRows(this.props.initRows);
  }

  /**
   * 添加并更新rows数据
   * @param {*} rows
   */
  _putAllRows(rows = []) {
    rows.length &&
      rows.forEach((row) => {
        this._rowsData[row[this.props.rowKey]] = row;
      });
  }

  /**
   * 通过rowKey获取row对象数据
   * @param {*} rowKey
   */
  _getRowData(rowKey, selectRows) {
    let p = this._rowsData || {};
    if (selectRows && selectRows.length) {
      selectRows.forEach((r) => {
        p[r.id] = r;
      });
    }
    if (rowKey) {
      return p[rowKey] || {};
    }
    return {};
  }

  /**
   * required props:
   *      1: tableApi     //请求配置
   *      2: columns      //数据配置
   * PS: onChange为Form组件绑定使用方法, 获取value使用onSubmit方法
   */
  static propTypes = {
    //init
    initRows: PropTypes.array, //初始数据对象（与form组件中的initialValue组合使用）
    //modal props
    showModal: PropTypes.bool, //是否展示为模态框
    showSelectValue: PropTypes.bool, //是否展示已选择的值
    visible: PropTypes.bool, //模态框展示状态
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]), //模态框标题
    width: PropTypes.number, //模态框宽度
    onSubmit: PropTypes.func, //确认回调
    onChangeRowMap: PropTypes.func, //确认数据集回调方法（参数为{ rowKey: row }）
    tableFormWillOpen: PropTypes.func, // 弹窗前的钩子
    onCancel: PropTypes.func, //取消回调
    modalProps: PropTypes.object, //更多模态框属性
    allowTreeSelect: PropTypes.bool, //是否允许树形结构选择
    //columns
    columns: PropTypes.array.isRequired, //数据配置
    //search props
    searchType: PropTypes.oneOf(["grid", "inline"]),
    cols: PropTypes.object,
    searchProps: PropTypes.object, //更多搜索栏属性
    //table props
    selectType: PropTypes.oneOf(["checkbox", "radio"]), //多选、单选
    /**
     * tableApi: {
     *      path: PropTypes.string,       请求路径
     *      key: PropTypes.string,        请求key 默认：wizTableForm@defaultSearch
     *      apiParams: PropTypes.object,  请求参数
     *      dataKey: PropTypes.string     数据key 默认：data
     * }
     */
    tableApi: PropTypes.object.isRequired, //请求配置
    initApiSearch: PropTypes.bool, //默认是否查询
    rowKey: PropTypes.string,
    rowTitle: PropTypes.string, //展示已选数据title
    rowName: PropTypes.string, //展示已选数据key
    showNum: PropTypes.bool,
    isScroll: PropTypes.bool,
    tableSize: PropTypes.string, //table props size
    paginationSize: PropTypes.string, //pagination props size
    tableProps: PropTypes.object, //更多表格属性

    //select props
    showSelect: PropTypes.bool, //是否展示选中集合
    selectItem: PropTypes.oneOfType([PropTypes.func, PropTypes.element]), //选中列表行展示
    selectTitle: PropTypes.string, //选中title
    itemName: PropTypes.string, //展示选中数据key
    selectProps: PropTypes.object, //更多选中列表属性

    //及联参数
    links: PropTypes.object, //需要级联的key和中文名称，格式{'state':'状态'}
    linksKeyFormat: PropTypes.object, //需要级联的key转换,格式{'state':'status'}
    //other props
    showValue: PropTypes.bool, //是否展示已选数据
    onClearWiz: PropTypes.func, //重置回调方法
    renderValue: PropTypes.func, //自定义渲染选中结果(value, valueRows) => renderValue(value, valueRows)
    setData: PropTypes.func, //处理列表数据

    showArrow: PropTypes.bool, //是否显示Wizselect小箭头

    disabled: PropTypes.bool,

    needSelect: PropTypes.bool, //是否必选
  };

  static defaultProps = {
    initRows: [],
    //modal props
    showModal: true,
    showSelectValue: true,
    visible: false,
    title: "选择",
    width: 1000,
    modalProps: {},
    //columns
    columns: [],
    //search props
    searchType: "grid",
    cols: { xs: 14, md: 12, xl: 10 },
    searchProps: {},
    //table props
    selectType: "checkbox",
    initApiSearch: true,
    rowKey: "id",
    rowTitle: null,
    rowName: "name",
    showNum: false,
    isScroll: true,
    tableProps: {},
    //select props
    showSelect: true,
    selectTitle: "",
    itemName: "name",

    //wizSelect props
    selectProps: {},

    //other props
    showValue: true,
    showArrow: true,

    disabled: false,
    needSelect: true,
  };

  propsAndStateOnChange = {
    visible: this._visibleOnChange.bind(this),
    modalVisible: this._modalVisibleOnChange.bind(this),
    tableData: this._tableDataOnChange.bind(this),
    initRows: this._initRowsOnChange.bind(this),
    linksValues: this._linksValues.bind(this),
    treeData: this._treeDataOnChange.bind(this),
  };

  /**
   * 监控及联数据是否变化
   */
  _linksValues(nextProps, nextState) {
    this._onClear(false);
    return true;
  }

  /**
   * 打开模态框时查询数据
   * @param {*} nextProps
   * @param {*} nextState
   */
  _visibleOnChange(nextProps, nextState) {
    if (nextProps.visible !== this.state.modalVisible) {
      nextState.modalVisible = nextProps.visible;
      if (nextProps.visible) {
        this._searchApiData();
      }
    }
    return true;
  }

  /**
   * 打开模态框时查询数据
   * @param {*} nextProps
   * @param {*} nextState
   */
  _modalVisibleOnChange(nextProps, nextState) {
    if (
      nextState.modalVisible &&
      nextState.modalVisible != this.state.modalVisible
    ) {
      this._searchApiData();
    }
    return true;
  }

  /**
   * 添加并更新rows数据
   * @param {*} nextPropfs
   * @param {*} nextState
   */
  _tableDataOnChange(nextProps, nextState) {
    if (nextProps.tableData) {
      let list = getPageData(nextProps.tableData).list;
      if (this.props.setData) {
        this.props.setData(list);
      }
      this._putAllRows(list);
    }
    return true;
  }

  /**
   * 查询树结构
   * @param {*} nextPropfs
   * @param {*} nextState
   */
  _treeDataOnChange(nextProps, nextState) {
    if (nextProps.treeData.code === 1) {
      if (nextProps.treeData.data && nextProps.treeData.data instanceof Array) {
        nextProps.treeData.data.forEach((data) => {
          this.giveKey(data);
        });
      }
    }
    return true;
  }

  /**给数据加key */
  giveKey(data) {
    data.key = data.value;
    if (data.children && data.children instanceof Array) {
      data.children.forEach((children) => {
        this.giveKey(children);
      });
    }
  }
  _initRowsOnChange(nextProps, nextState) {
    if (nextProps.initRows) {
      if (nextProps.initRows.length === 0) {
        nextState.valueKeys = [];
        nextState.valueRows = [];
        nextState.timestamp = new Date().getTime();
      } else {
        this._initData.valueRows = nextProps.initRows;
        this._putAllRows(nextProps.initRows);
        let { value } = this.state;
        let { selectType, rowKey } = this.props;
        let valueRows = [];
        if (selectType !== "checkbox") {
          value && valueRows.push(this._rowsData[value]);
        } else {
          value &&
            value.length &&
            value.forEach((key) => {
              valueRows.push(this._rowsData[key]);
            });
        }
        nextState.valueKeys = valueRows.map((e) => e[rowKey]);
        nextState.valueRows = valueRows;
        nextState.timestamp = new Date().getTime();
      }
    }
    return true;
  }

  _componentDidMount = () => {
    //重置回调方法
    if (this.props.onClearWiz) {
      this.props.onClearWiz(this._onClear);
    }
    if (this.props.initApiSearch) {
      if (this.props.showModal) {
        if (this.props.visible) {
          this._searchApiData();
        }
      } else {
        this._searchApiData();
      }
    }
  };

  /**
   * 请求数据
   * @param {*} other
   */
  _searchApiData(other = {}) {
    let { linksValues, linksKeyFormat } = this.props;
    let {
      path,
      key = "wizTableForm@defaultSearch",
      apiParams = {},
    } = this.props.tableApi;
    let params = {
      ...apiParams,
      ...this.state.searchParams,
      ...other,
      ...this.fitterFieldsValue(linksValues, linksKeyFormat),
    };
    this.doAction({
      path,
      payload: {
        key,
        apiParams: params,
      },
    });
  }

  /**
   * 过滤查询字段值为undefined&null&''&'null'的字段,不需要进行查询
   * @param {Object} fieldsValue
   */
  fitterFieldsValue(fieldsValue = {}, linksKeyFormat = {}) {
    let fitterValues = {};
    Object.keys(fieldsValue).forEach((key) => {
      let value = fieldsValue[key];
      if (
        value !== null &&
        value !== undefined &&
        value !== "" &&
        value !== "null"
      ) {
        if (linksKeyFormat[key]) {
          fitterValues[linksKeyFormat[key]] = value;
        } else {
          fitterValues[key] = value;
        }
      }
    });
    return fitterValues;
  }

  /**
   * 重置
   */
  _onClear = (isReset = true) => {
    if (isReset) {
      this.setState(
        {
          ...this._initData,
          selectedKeys: [],
          selectedRows: [],
          timestamp: new Date().getTime(),
        },
        () => this.triggerChange(this.state.value)
      );
    } else {
      this.setState(
        {
          value: undefined,
          valueRows: [],
          selectedKeys: [],
          selectedRows: [],
          timestamp: new Date().getTime(),
        },
        () => this.triggerChange(this.state.value)
      );
    }
  };

  /**
   * 选中展示列表（多选）删除选中
   * @param {*} rowKey
   */
  _selectClear(rowKey) {
    let { selectedKeys, selectedRows } = this.state;
    let keys = [];
    let rows = [];
    if (rowKey) {
      for (let i = 0; i < selectedKeys.length; i++) {
        if (rowKey !== selectedKeys[i]) {
          keys.push(selectedKeys[i]);
          rows.push(selectedRows[i]);
        }
      }
    }
    this.setState({
      selectedKeys: keys,
      selectedRows: rows,
      timestamp: new Date().getTime(),
    });
    //通过selectedRows联动表单选中项,xyguo 2020/11/10
    const { onSelectedRows } = this.props;
    onSelectedRows && onSelectedRows(rows);
  }

  /**
   * 选中展示列表（多选）行渲染（可自定义）
   * @param {*} item
   */
  _renderTableSelectItem(item) {
    if (this.props.selectItem) {
      return this.props.selectItem(item);
    }
    if (this.props.rowTitle) {
      return (
        <WizRow>
          <WizCol span={12}>
            <WizTooltip
              title={item[this.props.rowTitle] || ""}
              placement="topLeft"
            >
              {item[this.props.rowTitle] || ""}
            </WizTooltip>
          </WizCol>
          <WizCol span={12}>
            <WizTooltip
              title={
                item[this.props.itemName] || item[this.props.rowName] || ""
              }
              placement="topLeft"
            >
              {item[this.props.itemName] || item[this.props.rowName] || ""}
            </WizTooltip>
          </WizCol>
        </WizRow>
      );
    }
    return (
      <WizRow>
        <WizCol>
          <WizTooltip
            title={item[this.props.itemName] || item[this.props.rowName] || ""}
            placement="topLeft"
          >
            {item[this.props.itemName] || item[this.props.rowName] || ""}
          </WizTooltip>
        </WizCol>
      </WizRow>
    );
  }

  /**
   * 选中展示列表（多选）
   * @param {*} select
   * @param {*} selectedRows
   */
  _renderTableListSelect(select, selectedRows) {
    let listSelectProps = {
      rows: selectedRows,
      rowKey: this.props.rowKey,
      type: this.props.selectTitle,
      handerClear: (rowKey) => this._selectClear(rowKey),
      itemRender: (item) => this._renderTableSelectItem(item),
    };
    if (select) {
      return <WizListSelect className="select-list" {...listSelectProps} />;
    }
    return null;
  }

  /**
   *
   * @param {*} keys
   * @param {*} rows
   */
  _onSelectTableRows(keys, rows) {
    let nextKeys = [];
    let nextRows = [];
    if (this.props.selectType !== "checkbox") {
      nextKeys = keys;
      nextRows = rows;
    } else if (keys && keys.length > 0) {
      keys.forEach((key) => {
        nextKeys.push(key);
        nextRows.push(this._rowsData[key]);
      });
    }

    if (!this.props.showModal && this.props.renderValue) {
      return this.props.renderValue(nextKeys, nextRows);
    }
    this.setState({
      selectedKeys: nextKeys,
      selectedRows: nextRows,
      timestamp: new Date().getTime(),
    });
    const { onSelectedRows } = this.props;
    onSelectedRows && onSelectedRows(nextRows);
  }

  /**
   * 列表搜索选择
   * @param {*} showModal
   */
  _renderContent(showModal) {
    //londing
    let { path } = this.props.tableApi;
    let londing = false;
    if (path) {
      let [business, action] = path.split("/");
      londing = this.props[business + "Loading"];
    }
    // let organizationLonding = this.props
    //state
    let { selectedRows, selectedKeys, showDataTable } = this.state;
    //other
    let { selectType, showSelect, columns } = this.props;
    let select = selectType === "checkbox" && showSelect;
    //search
    let { searchType, cols, searchProps } = this.props;
    //table
    let {
      tableData,
      treeData,
      rowKey,
      showNum,
      isScroll,
      tableSize,
      paginationSize,
      tableProps,
    } = this.props;
    //data
    const dataItems = getPageData(tableData);

    let searchBarProps = {
      className: "search",
      columns,
      type: searchType,
      cols,
      onSearch: (values) =>
        this.setState(
          {
            searchParams: values,
            timestamp: new Date().getTime(),
          },
          () => this._searchApiData()
        ),
      collapse: false,
      ...searchProps,
    };

    tableSize = tableSize ? tableSize : showModal ? "small" : "default";
    paginationSize = paginationSize
      ? paginationSize
      : showModal
      ? "small"
      // : "default";
      : "small";
    let dataTableProps = {
      scroll: { y: 420, x: "max-content" },
      columns,
      dataItems,
      selectType,
      rowKey,
      showNum,
      isScroll,
      selectedRowKeys: selectedRows.map((item) => (item ? item[rowKey] : "")),
      onChange: ({ pageNum, pageSize }) =>
        this._searchApiData({ current: pageNum, size: pageSize }),
      onSelect: (keys, rows) => this._onSelectTableRows(keys, rows),
      ...tableProps,
    };

    return (
      <div className="tableform-wrp">
        <div className={ select ? "tableform-left" : 'tableform' }>
          <WizSpin tip={"加载中"} spinning={londing}>
            {showDataTable ? (
              <WizCard
                className={classnames(
                  "wizTableForm-card",
                  !showModal ? "pd-0" : "wizTableForm-card-withModal"
                )}
              >
                <WizSearchBar
                  {...searchBarProps}
                  ref={(r) => (this._searchBar = r)}
                />
                <WizDataTable size={"default"} {...dataTableProps} />
                <div className="pagination">
                  <WizDataTable.Pagination
                    showLessItems
                    size={paginationSize}
                    {...dataTableProps}
                  />
                </div>
              </WizCard>
            ) : (
              <React.Fragment>
                <WizTreeSelectList
                  leftViewSpan={24}
                  autoExpand={false}
                  showSelectList={false}
                  treeData={treeData.data || []}
                  treeProps={{ checkStrictly: true }}
                  checkedKeys={selectedKeys}
                  listCheck={selectedRows}
                  itemProps={{
                    icon: "unordered-list",
                    title: "组织",
                    tips: "请勾选所属组织",
                  }}
                  onChange={(selects) => {
                    let selectedKeys = selects.map((val) => Number(val.key));
                    let selectedRows = selects.map((val) => {
                      let key = Number(val.key);
                      return { id: key, rowKey: key, name: val.title, ...val };
                    });

                    this.setState({ selectedKeys, selectedRows });
                  }}
                />
              </React.Fragment>
            )}
          </WizSpin>
        </div>
        {
          select ? <div className="tableform-right">
            {this._renderTableListSelect(select, selectedRows)}
          </div> : null
        }

      </div>
    );
  }
  _render() {
    let { showModal, showSelectValue } = this.props;
    if (showModal) {
      let { title, width, modalProps, allowTreeSelect, isNotAuth = false } = this.props;
      let currentTypeText = "";
      if (this.state.showDataTable) {
        currentTypeText = "树形列表";
      } else {
        currentTypeText = "数据表格";
      }
      return (
        <>
          {showSelectValue ? this._renderSelectedValue() : null}
          <WizModal
            style={{ top: 20 }}
            visible={this.state.modalVisible}
            maskClosable={false}
            title={
              <div>
                {title}
                {allowTreeSelect ? (
                  <span style={{ marginLeft: 15 }}>
                    <span style={{ fontSize: 14 }}>切换成</span>
                    <WizButton
                      type="link"
                      style={{ padding: 0 }}
                      onClick={() => {
                        this.setState({
                          showDataTable: !this.state.showDataTable,
                        });

                        this.doAction({
                          path: "organization/getNodeTreeData",
                          payload: {
                            key: "treeData",
                            apiParams: !!isNotAuth ? {isNotAuth} : {},
                          },
                          requireLoading: true,
                        });
                      }}
                    >
                      {currentTypeText}
                    </WizButton>
                  </span>
                ) : null}
              </div>
            }
            width={width}
            onOk={(e) => this._onSubmit(e)}
            onCancel={(e) => this._onCancel(e)}
            {...modalProps}
          >
            {this._renderContent(showModal)}
          </WizModal>
        </>
      );
    } else {
      return this._renderContent(showModal);
    }
  }

  /**
   * 模态框模式下选中结果渲染（可自定义）
   */
  _renderSelectedValue() {
    if (this.props.showValue) {
      if (this.props.renderValue) {
        return this.props.renderValue(this.state.value, this.state.valueRows);
      }
      return this._renderValue();
    }
    return null;
  }

  /**
   * 模态框模式下选中结果渲染（默认）
   */
  _renderValue() {
    let { value, valueRows, timestamp, showArrow } = this.state;
    let mode = "";
    let defaultValue;
    if (this.props.selectType !== "checkbox") {
      defaultValue = this._rowsData[value] ? value : undefined;
    } else {
      mode = "multiple";
      defaultValue = [];
      value &&
        value.length &&
        value.forEach((key) => {
          this._rowsData[key] && defaultValue.push(key);
        });
    }

    return (
      <div
        key={"wizSelectDiv_" + timestamp}
        onClick={() =>
          !this.props.disabled && this._wizSelectOnClick(value, valueRows)
        }
      >
        <WizSelect
          className="wizTableForm-default-select"
          key={"wizSelect_" + defaultValue + "_" + timestamp}
          defaultValue={defaultValue}
          mode={mode}
          open={false}
          allowClear={true}
          placeholder={this.props.placeholder}
          showArrow={showArrow}
          onChange={(value, option) => this._wizSelectOnChange(value, option)}
          disabled={this.props.disabled}
          {...this.props.selectProps}
        >
          {this._renderOptions(valueRows)}
        </WizSelect>
      </div>
    );
  }

  /**
   * 校验需要及联的数据是否有参数
   */
  checkLinksValue = () => {
    let { links, linksValues } = this.props;
    if (!links) {
      return true;
    }
    let _value = this.fitterFieldsValue(linksValues);
    let value = {};
    for (const key in _value) {
      let v = _value[key];
      let valueType = getType(v);
      if ((valueType === "Array" || valueType === "Object") && v.length) {
        value[key] = v;
      } else if (valueType === "String" && v !== "") {
        value[key] = v;
      } else if (valueType === "Number" || valueType === "Boolean") {
        value[key] = v;
      }
    }
    let valueKeys = Object.keys(value);
    let linksValuesKeys = Object.keys(linksValues);
    if (valueKeys.length !== linksValuesKeys.length) {
      let alertText;
      for (let key in links) {
        let _value = value[key];
        if (!_value) {
          if (alertText) {
            alertText = alertText + "、" + links[key];
          } else {
            alertText = links[key];
          }
        }
      }
      wizNotice.error(`请先选择 ${alertText} `);
      return false;
    }
    return true;
  };

  /**
   * WizSelect onClick
   * @param {*} value
   * @param {*} valueRows
   */
  _wizSelectOnClick(value, valueRows) {
    const { tableFormWillOpen, selectType } = this.props;
    if (tableFormWillOpen && !tableFormWillOpen()) return false;
    if (!this.checkLinksValue()) {
      return false;
    }
    let selectedKeys = selectType !== "checkbox" ? [value] : value;
    this.setState({
      modalVisible: true,
      selectedKeys,
      selectedRows: valueRows,
      timestamp: new Date().getTime(),
    });
  }

  /**
   * foreach options
   * @param {*} options
   */
  _renderOptions(options) {
    if (options && options.length) {
      let { rowKey, rowName } = this.props;
      return options.map((row, i) =>
        this._renderOption(row, rowKey, rowName, i)
      );
    }
    return null;
  }

  /**
   * WizSelect.Option
   * @param {*} row
   * @param {*} rowKey
   * @param {*} rowName
   * @param {*} i
   */
  _renderOption(row, rowKey, rowName, i) {
    if (row) {
      return (
        <WizSelect.Option
          key={row[rowKey] + "_" + i}
          value={row[rowKey]}
          title={row[rowName]}
        >
          {row[rowName]}
        </WizSelect.Option>
      );
    }
  }

  /**
   * WizSelect.func onChange
   * @param {*} value
   * @param {*} option
   */
  _wizSelectOnChange(value, option) {
    let valueRows = [];
    let rows = this.state.valueRows;
    let { rowKey } = this.props;
    if (value && rows) {
      let index = 0;
      for (let i = 0; i < rows.length; i++) {
        if (index === value.length) {
          break;
        }
        let row = rows[i];
        if (value[index] === row[rowKey]) {
          valueRows.push(row);
          index++;
        }
      }
    }
    this.setState({ value, valueRows, timestamp: new Date().getTime() });
    this.triggerChange(value, valueRows);
  }

  /**
   * 取消选择
   * @param {*} e
   */
  _onCancel(e) {
    let selectedKeys;
    let selectedRows = this.state.valueRows;
    if (this.state.value) {
      if (this.props.selectType !== "checkbox") {
        selectedKeys = [this.state.value];
      } else {
        selectedKeys = this.state.value;
      }
    } else {
      selectedKeys = [];
    }
    if (this.props.onCancel) {
      this.props.onCancel(e);
      this.setState({
        selectedKeys,
        selectedRows,
        searchParams: {},
        timestamp: new Date().getTime(),
      });
    } else {
      this.setState({
        modalVisible: false,
        selectedKeys,
        selectedRows,
        searchParams: {},
        timestamp: new Date().getTime(),
      });
    }
    this._clearSearchParams();
  }

  /**
   * 确认选择
   * @param {*} e
   */
  _onSubmit(e) {
    let { onSubmit, showModal, selectType, needSelect } = this.props;
    let value;
    let valueRows = this.state.selectedRows;
    if (selectType !== "checkbox") {
      if (this.state.selectedKeys && this.state.selectedKeys.length > 0) {
        value = this.state.selectedKeys[0];
      }
    } else {
      value = this.state.selectedKeys;
    }
    if (
      needSelect &&
      (value === undefined ||
        value === null ||
        value === "" ||
        value.length === 0)
    ) {
      wizNotice.warn("请选择一条数据");
      return;
    }
    this.setState(
      { value, valueRows, searchParams: {}, timestamp: new Date().getTime() },
      () => {
        this._clearSearchParams();
        if (onSubmit) {
          let obj = {
            value,
            valueRows,
          };
          onSubmit(obj, e);
        }
        if (showModal && this.state.modalVisible) {
          this.setState({
            modalVisible: false,
            timestamp: new Date().getTime(),
          });
        }

        this.triggerChange(value, valueRows);
      }
    );
  }

  /**
   * 清除搜索条件
   */
  _clearSearchParams() {
    if (this._searchBar && this._searchBar.resetFields) {
      this._searchBar.resetFields();
    }
  }

  /**
   * form绑定 onChange
   * @param {*} nextTargetValues
   */
  triggerChange(nextTargetValues, selecrRows) {
    const { onChange, onChangeRowMap, _SEARCHBAR } = this.props;
    if (onChange) {
      if(_SEARCHBAR) {
        onChange({_SEARCHBAR, value: nextTargetValues, selecrRows})
      } else {
        onChange(nextTargetValues, selecrRows);
      }
    }
    //
    if (onChangeRowMap) {
      let dataMap = {};
      if (nextTargetValues) {
        if (this.props.selectType !== "checkbox") {
          dataMap[nextTargetValues] = this._getRowData(nextTargetValues);
        } else {
          nextTargetValues.length &&
            nextTargetValues.forEach((value) => {
              dataMap[value] = this._getRowData(value, selecrRows);
            });
        }
      }
      onChangeRowMap(dataMap);
    }
  }
}

const mapStateToProps = (state, ownProps) => {
  let {
    path,
    key = "wizTableForm@defaultSearch",
    dataKey = "data",
  } = ownProps.tableApi;
  let tableData;
  let treeData = {};
  let load = {};
  if (path) {
    let [business, action] = path.split("/");
    tableData = modelUtils.getModelEntity(state[business], key);
    treeData = modelUtils.getModelEntity(state[business], "treeData");
    load = modelUtils.getLoadingState(state, business);
  }
  return {
    treeData,
    tableData: tableData && dataKey ? tableData[dataKey] : tableData,
    ...load,
  };
};

WizTableForm.Config = Config;

export default connect(mapStateToProps)(WizTableForm);
